import React, { forwardRef } from 'react';
import { Button } from '@mui/material';
import { BRAND, BRAND_RADIUS } from '../../theme/brandTokens';

export const primaryActionButtonSx = {
  minWidth: 0,
  borderRadius: BRAND_RADIUS.button,
  background: BRAND.accent,
  color: BRAND.onAccent,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 600,
  lineHeight: 1,
  minHeight: 48,
  boxSizing: 'border-box',
  py: 0,
  px: 2.5,
  textDecoration: 'none',
  boxShadow: 'none',
  transition: 'background 0.2s ease-in-out',
  '&:hover': {
    background: BRAND.accentDark,
    boxShadow: 'none',
    textDecoration: 'none',
  },
  '&.Mui-disabled': {
    background: BRAND.lineSoft,
    color: BRAND.textSubtle,
  },
};

const PrimaryActionButton = forwardRef(function PrimaryActionButton({ sx, variant = 'contained', ...props }, ref) {
  const mergedSx = Array.isArray(sx)
    ? [primaryActionButtonSx, ...sx]
    : [primaryActionButtonSx, sx];

  return (
    <Button
      ref={ref}
      variant={variant}
      disableElevation
      {...props}
      sx={mergedSx}
    />
  );
});

export default PrimaryActionButton;